export default "/images/vendor/@coreui/icons/svg/flag/cif-id.svg?314053cb997753b81eb70171ebb33145";